export const NumberOfdigitsafterDecimalIsOne = num => {
  let digits = String(num).split('.');

  if (digits && digits[1] && digits[1].length > 1) {
    return false;
  }
  return true;
};
